import { Component, OnInit, Input } from "@angular/core";
import { IbMmbVoluntaryRefundsService } from "../../services/ib-MmB-voluntary-refunds.service";
import { VoluntaryRefundsTransformerModel } from "@src/components/ib-MmB-booking-dashboard/components/ib-MmB-voluntary-refunds-tab/models/ib-voluntary-refunds-tab-transformer-model";
import { MMBDatalayerConstants } from "@src/components/services/ib-MmB-datalayer/constants/ib-MmB-datalayer-constants";
import { MmBAppConstants } from "@src/ib-MmB-constants";


@Component({
  selector: 'ib-mmb-voluntary-refunds-confirmation',
  templateUrl: './ib-MmB-voluntary-refunds-confirmation-view.component.html',
  styleUrls: ['./ib-MmB-voluntary-refunds-confirmation.component.scss']
})

export class IbMmBVoluntaryRefundsConfirmationComponent implements OnInit {
    @Input() currentStep;
    @Input() dataModelConfirmation: VoluntaryRefundsTransformerModel;

    constructor(
      private IbMmbVoluntaryRefundsService: IbMmbVoluntaryRefundsService
    ) {
      this.IbMmbVoluntaryRefundsService.updateWorkflowDatalayerInfo(MMBDatalayerConstants.DIGITAL_DATA_STEP.REFVBK, MmBAppConstants.QUADRIGAM.VOL_REFUND_PAGE_CONFIRMATION);
    }

    ngOnInit = (): void => {
      this.currentStep = this.currentStep + 1;
    };
}
